export const NOT_FOUND_PAGE_LINK = '/404';
export const PROPERTIES_PAGE_LINK = '/properties/:projectCode';
export const SHARED_FILTER_RESULT_PAGE_LINK = '/properties-share';
export const PROPERTIES_SHARE_RESULT_PAGE_LINK = '/inventory-result/:shareCode';
export const CREATE_SESSION_PAGE_LINK = '/session/new';
export const UPDATE_SESSION_PAGE_LINK = '/session/:sessionCode';
export const SESSIONS_PAGE_LINK = '/sessions';

// external link
export const HUB_HOME_PROFILE = '/:projectKey/:itemKey/:extendable';
